import {
    CheckCircleOutlined,
    ClockCircleOutlined,
    PhoneOutlined,
} from "@ant-design/icons";
import { Flex } from "antd";
import dayjs from "dayjs";
import { UserShortWithWork } from "tm-shared/types";

import { PrimaryText } from "@/shared/ui/Typography";

import {
    StyledMemberInfoContainer,
    StyledPhoneLink,
    StyledWorkStatus,
} from "../../Styled";

interface MemberInfoProps {
    member: UserShortWithWork;
}

export const MemberInfo = ({ member }: MemberInfoProps) => {
    return (
        <StyledMemberInfoContainer>
            <Flex gap="6px" align="flex-start" justify="flex-start">
                <PrimaryText>{member.userInfo.fullName}</PrimaryText>
            </Flex>

            <StyledWorkStatus>
                {member.isWorking ? (
                    <>
                        <CheckCircleOutlined />
                        Почав о {dayjs(member.startedAt).format("H:mm")}
                    </>
                ) : (
                    <>
                        <ClockCircleOutlined />
                        Не на роботі
                    </>
                )}
            </StyledWorkStatus>

            <StyledPhoneLink href={`tel:${member.userInfo.phone}`}>
                <PhoneOutlined />
                {member.userInfo.phone}
            </StyledPhoneLink>
        </StyledMemberInfoContainer>
    );
};
